$(function () {
    inicializarToggleBusquedaAvanzadaMenu();
});

window.inicializarToggleBusquedaAvanzadaMenu = function () {
    window.busquedaAvanzadaMenuElement  = $('#header-advanced-search')[0];
    window.busquedaAvanzadaMenuCollapse = new bootstrap.Collapse(busquedaAvanzadaMenuElement, {
        toggle: false // Esto evita que se active automáticamente al crear la instancia
    });

    busquedaAvanzadaMenuElement.addEventListener('shown.bs.collapse', function () {
        inicializarBusquedaAvanzadaMenu('editorial');
        inicializarBusquedaAvanzadaMenu('coleccion');
        inicializarBusquedaAvanzadaMenu('materia');
        inicializarBusquedaAvanzadaMenu('idioma');
        // inicializarBusquedaAvanzadaTexto();
    });
}

window.toggleBusquedaAvanzadaMenu = function () {
    busquedaAvanzadaMenuCollapse.toggle(); // Cambia el estado del elemento colapsable
}

/**
 * Initialize the advanced searcher
 */
window.inicializarBusquedaAvanzadaMenu = function (field = '') {
    if (!$(`#busquedaAvanzadaMenuFormularioCampo${pascalCase(field)}`).hasClass('loaded')) {
        $(`#busquedaAvanzadaMenuFormularioCampo${pascalCase(field)}`).addClass('loaded').select2({
            language:           'es',
            theme:              'bootstrap-5',
            width:              'resolve',
            minimumInputLength: 0,
            allowClear:         true,
            ajax:               {
                url:            eval(`url${pascalCase(field)}`) + '/get',
                type:           'POST',
                dataType:       'json',
                delay:          250, // wait 250 milliseconds before triggering the request
                data:           function (params) {
                    // Query parameters will be ?search=[term]&type=public
                    let data = {
                        searchFields:   {
                            titulo: params.term
                        },
                        conditions:     {
                            titulo: 'like'
                        },
                        resultsPerPage: 10,
                        currentPage:    params.page || 1,
                        count:          1,
                        orderBy:        ['titulo']
                    };
                    if (field === 'materia') {
                        data.join = {
                            idioma_materia: {
                                on: [
                                    'idioma_materia.materia_id',
                                    'materias.id'
                                ],
                            },
                            idiomas:        {
                                on:           [
                                    'idiomas.id',
                                    'idioma_materia.idioma_id'
                                ],
                                searchFields: {
                                    codigo_iso: locale,
                                },
                            }
                        };
                    }
                    if (field === 'asignatura') {
                        data.join = {
                            asignatura_idioma: {
                                on: [
                                    'asignatura_idioma.asignatura_id',
                                    'asignaturas.id'
                                ],
                            },
                            idiomas:           {
                                on:           [
                                    'idiomas.id',
                                    'asignatura_idioma.idioma_id'
                                ],
                                searchFields: {
                                    codigo_iso: locale,
                                },
                            }
                        };
                    }
                    if (field === 'nivelEducativo') {
                        data.join = {
                            idioma_nivel_educativo: {
                                on: [
                                    'idioma_nivel_educativo.nivel_educativo_id',
                                    'niveles_educativos.id'
                                ],
                            },
                            idiomas:                {
                                on:           [
                                    'idiomas.id',
                                    'idioma_nivel_educativo.idioma_id'
                                ],
                                searchFields: {
                                    codigo_iso: locale,
                                },
                            }
                        };
                    }
                    if (field === 'comunidadAutonoma') {
                        data.join = {
                            comunidad_autonoma_idioma: {
                                on: [
                                    'comunidad_autonoma_idioma.comunidad_autonoma_id',
                                    'comunidades_autonomas.id'
                                ],
                            },
                            idiomas:                   {
                                on:           [
                                    'idiomas.id',
                                    'comunidad_autonoma_idioma.idioma_id'
                                ],
                                searchFields: {
                                    'idiomas.codigo_iso': locale,
                                },
                            }
                        };
                    }
                    if (field === 'coleccion' && $('#busquedaAvanzadaMenuFormularioCampoEditorial').val() !== null) {
                        data.searchFields.editorial_id = $('#busquedaAvanzadaMenuFormularioCampoEditorial').val();
                    }
                    if (field === 'idioma') {
                        data.searchFields.titulo              = undefined;
                        data.conditions.titulo                = undefined;
                        data.searchFields['titulo_' + locale] = params.term;
                        data.conditions['titulo_' + locale]   = 'like';
                        data.orderBy                          = ['titulo_' + locale];
                    }
                    return data;
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;

                    // Transform the results into the format expected by Select2.
                    let results = [];
                    $.each(data.list, function (index, item) {
                        let result = {
                            id:   item.id,
                            text: item.titulo,
                        };
                        switch (field) {
                            case 'idioma':
                                result.text = item['titulo_' + locale];
                                break;
                            case 'materia':
                            case 'asignatura':
                            case 'nivelEducativo':
                                result.id = item.codigo;
                                break;
                        }
                        results.push(result);
                    });

                    // Transforms the top-level key of the response object from 'items' to 'results'
                    return {
                        results:    results,
                        pagination: {
                            more: (params.page * 10) < data.numFound
                        }
                    };
                },
            },
            // templateResult: formatRepo,
            // templateSelection: formatRepoSelection
        });
    }
}

/**
 * Submit Navbar Advanced Search Form
 */
window.enviarBusquedaAvanzada = function () {
    event.preventDefault();

    // let tipo = $('#busquedaMenuFormularioSelectTipoArticulo').val();
    let tipo = $('#busquedaAvanzadaMenuFormulario .nav-link.active').attr('data-tipo');
    let url  = `${urlArticulo}?buscador=${encodeURIComponent($('#busquedaAvanzadaMenuFormularioCampoTitulo').val().length ? $('#busquedaAvanzadaMenuFormularioCampoTitulo').val().trim() : '*')}${tipo !== '*' ? '&tipo=' + tipo : ''}`;


    // let url = urlArticulo + '?buscador=';
    $('#busquedaAvanzadaMenuFormulario').find('input, select').each(function () {
        let id    = $(this).val();
        let text  = $(this).find(':selected').text();
        let value = text;
        // if ($(this).attr('field') == 'titulo') {
        //     if (id.length) {
        //         url += id;
        //     } else {
        //         url += '*';
        //     }
        // }

        // Filtrado de campos por tipo de artículo
        if (
            tipo !== 't' &&
            (
                $(this).attr('name') == 'curso' ||
                $(this).attr('field') == 'asignatura' ||
                $(this).attr('field') == 'nivelEducativo' ||
                $(this).attr('field') == 'comunidadAutonoma'
            )
        ) {
            return;
        }

        if ($(this).attr('name') == 'autor' && id.length) {
            value = id;
        }

        if (null !== value && value.length) {
            if ($(this).attr('field') == 'materia') {
                value = id + '|' + text;
            }
            if ($(this).attr('field') == 'asignatura') {
                value = id + '|' + text;
            }
            if ($(this).attr('name') == 'curso') {
                if (!id.length) {
                    return;
                } else {
                    value = id;
                }
            }

            url += '&' + $(this).attr('name') + '=' + encodeURIComponent(value);
        }
    });
    window.location = url;
}

/**
 * Clean Navbar Advanced Search Filters
 */
window.limpiarFiltrosBusquedaAvanzada = function () {
    $('#busquedaAvanzadaMenuFormulario').find('input, select').val('').change();
}

window.seleccionarBusquedaAvanzadaTexto = function () {
    $('#busquedaMenuFormularioSelectTipoArticulo').val('t').change();
    // inicializarBusquedaAvanzadaTexto();
}

/**
 * Initialize the advanced searcher by types articles
 */
window.inicializarBusquedaAvanzadaTipo = function (tipo = null) {
    if (tipo === 't') {
        loadCursos();
        inicializarBusquedaAvanzadaMenu('asignatura');
        inicializarBusquedaAvanzadaMenu('comunidadAutonoma');
        inicializarBusquedaAvanzadaMenu('nivelEducativo');
        $('.sectionBusquedaAvanzadaMenuTexto').show();
    } else {
        $('.sectionBusquedaAvanzadaMenuTexto').hide();
    }
}
// window.inicializarBusquedaAvanzadaTexto = function () {
//     let tipo = $('#busquedaMenuFormularioSelectTipoArticulo').val();
//     if (tipo === 't' && $('#header-advanced-search').hasClass('show')) {
//         loadCursos();
//         inicializarBusquedaAvanzadaMenu('asignatura');
//         inicializarBusquedaAvanzadaMenu('comunidadAutonoma');
//         inicializarBusquedaAvanzadaMenu('nivelEducativo');
//         $('.sectionBusquedaAvanzadaMenuTexto').show();
//     } else {
//         $('.sectionBusquedaAvanzadaMenuTexto').hide();
//     }
// }

/**
 * Loads courses
 */
window.loadCursos = function () {
    if (!$('#busquedaAvanzadaMenuFormularioCampoCurso').hasClass('loaded')) {
        $.ajax({
            url:      urlArticulo + '/get',
            type:     'POST',
            data:     {
                findIn:         [
                    'solr',
                ],
                facets:         [
                    'curso',
                ],
                defaultFacets:  0,
                resultsPerPage: 0,
            },
            dataType: 'json',
        })
         .done(function (response) {
             $('#busquedaAvanzadaMenuFormularioCampoCurso').addClass('loaded');
             $.each(response.facets.curso, function (index, item) {
                 $('#busquedaAvanzadaMenuFormularioCampoCurso').append(`<option value="${index}">${index}</option>`);
             });
         })
         .fail(function (jqXHR, status, error) {
             if (jqXHR.status) {
                 let errors = '';
                 if (jqXHR.status === 422) {
                     errors = composeValidationError(jqXHR.responseJSON.errors);
                 } else if (jqXHR.responseJSON.message) {
                     errors = jqXHR.responseJSON.message;
                 }
                 pNotifyError(errors);
             }
         });
    }
}
